import mapboxgl from 'mapbox-gl';
import config from 'core/config';
import 'mapbox-gl/dist/mapbox-gl.css';
import Component from 'navigation/component/Component';
import { bindMethod } from 'helpers/bind';
import scroll from 'core/scroll';
mapboxgl.accessToken = config.mapbox;
class Map extends Component {
    map;
    markers;
    popups;
    constructor(el, options) {
        super(el, options);
        this.map = new mapboxgl.Map({
            container: this.el,
            minZoom: 6,
            maxZoom: 18,
            language: this.el.dataset.lang || 'fr'
        });
    }
    zoomIn = () => this.map && this.map.zoomIn();
    zoomOut = () => this.map && this.map.zoomOut();
    initialized() {
        super.initialized();
        this.resize();
    }
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const method = bindMethod(add);
        const methodSignal = add ? 'on' : 'off';
        this.refs.zoomIn[method]('click', this.zoomIn);
        this.refs.zoomOut[method]('click', this.zoomOut);
        scroll[methodSignal](this.onScroll);
    }
    onScroll = () => {
        this.map && this.map.resize();
    };
    deleteMarkersAndPopUp = (markers, popups) => {
        setTimeout(() => {
            for (let i = 0; i < markers.length; i++) {
                const marker = markers[i].getElement();
                marker.onclick = null;
                popups[i].remove();
                markers[i].remove();
            }
        }, 1000);
    };
    setActiveMarker = (index) => {
        if (index !== null) {
            this.markers.forEach((marker, i) => {
                marker.getElement().classList.toggle('map__marker--active', i === index);
                marker.getElement().classList.toggle('map__marker--inactive', i !== index);
            });
            const current = this.markers[index]?.getLngLat();
            this.map.flyTo({ center: current, zoom: 13, animate: true });
        }
        else {
            this.markers.forEach(marker => {
                marker.getElement().classList.remove('map__marker--active');
                marker.getElement().classList.remove('map__marker--inactive');
            });
            const bounds = new mapboxgl.LngLatBounds();
            this.markers.forEach(marker => bounds.extend(marker.getLngLat()));
            this.map.fitBounds(bounds, { maxZoom: 12, animate: true });
        }
    };
    createMarkersAndPopups = (points) => {
        if (this.markers)
            this.deleteMarkersAndPopUp(this.markers, this.popups);
        this.markers = [];
        this.popups = [];
        points.forEach(([point, text, button], i) => {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            if (button)
                wrapper.appendChild(button);
            const popup = new mapboxgl.Popup({ offset: 25 }).setDOMContent(wrapper);
            this.popups.push(popup);
            const el = document.createElement('div');
            el.className = 'map__marker';
            el.onclick = this.onMarkerClicked(i);
            const marker = new mapboxgl.Marker(el)
                .setLngLat(point)
                .addTo(this.map)
                .setPopup(popup);
            this.markers.push(marker);
        });
    };
    onMarkerClicked = i => event => {
        this.emit('clicked', i);
    };
    setMarkers(points) {
        const bounds = new mapboxgl.LngLatBounds();
        points.forEach(p => bounds.extend(p[0]));
        const options = { maxZoom: 12, animate: true, padding: 30 };
        if (points.length) {
            if (!this.markers)
                options.animate = false;
            this.map.fitBounds(bounds, options);
        }
        this.createMarkersAndPopups(points);
    }
    resize() {
        this.map.resize();
    }
}
export default Map;
